import { useEffect } from 'react';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { EVENTS } from '@r1-frontend/shared/constants/analytics';

/**
 * Хук для отправки referrer в GA метрику,
 * в label пишется путь без домена.
 * Использовать на конечной странице.
 */
export const useSendReferrerToGA = (category: string, action: string) => {
    const sendReferrer = () => {
        const {
            document: { referrer = '/' },
            location: { origin },
        } = window;
        const withoutOrigin = referrer.replace(origin, '');

        dataLayerPush({
            event: EVENTS.UAevent,
            category,
            action,
            label: withoutOrigin,
        });
    };

    useEffect(() => {
        sendReferrer();
    }, []);
};
